<p>
    <button matButton (click)="createUsageRate()"><mat-icon>add</mat-icon> Créer une nouvelle grille de vente</button>
</p>

<br>

<ag-grid-angular
    style="width: 100%; height: 100%;"
    [columnDefs]="columns"
    [autoSizeStrategy]="autoSizeStrategy"
    [loading]="true"
    [localeText]="localeText"
    [getRowId]="getRowId"
    (rowDoubleClicked)="selectUsageRate($event.data?.uuid)"
    (gridReady)="onGridReady($event)"
/>